export { };
export const defaults = {
	app: {
		applicationId: 'mglappmodularsystemv2',
		pageEditorClass: 'is-page-editor',
		generalErrorCodes: [
			{ "code": '116000', "message": 'Es trat ein Fehler beim Zugriff auf das Bestandssystem auf' },
			{ "code": '116001', "message": 'Die Anlage im Bestandssystem war nicht möglich' }
		],
		validatorRules: {
			rules: {
				Anrede: {
					required: true
				},
				Vorname: {
					required: true,
					maxlength: 40,
					nonumber: true,
					pattern: /^[^\(\)\%\\\~\"\?\#]*$/
				},
				Nachname: {
					required: true,
					maxlength: 40,
					nonumber: true,
					pattern: /^[^\(\)\%\\\~\"\?\#]*$/
				},
				StrasseHausnummer: {
					required: true,
					minlength: 2,
					maxlength: 30,
					streetandnumber: true
				},
				Postleitzahl: {
					required: true,
					minlength: 5,
					maxlength: 5,
					pattern: "[0-9]+"
				},
				Ort: {
					required: true,
					maxlength: 30
				},
				Policendruck: {
					required: true
				},
				TelefonVorwahl: {
					inputcross: ['TelefonNummer'],
					maxlength: 8
				},
				TelefonNummer: {
					inputcross: ['TelefonVorwahl'],
					maxlength: 8
				},
				TelefonGeschaeftlichVorwahl: {
					inputcross: ['TelefonGeschaeftlichNummer'],
					maxlength: 8
				},
				TelefonGeschaeftlichNummer: {
					inputcross: ['TelefonGeschaeftlichVorwahl'],
					maxlength: 8
				},
				Email: {
					email: true
				},
				EmailBonuscode: {
					email: true,
					required: true
				},
				EmailSecondTry: {
					email: true,
					emailsecondtry: true
				},
				Ausbildungsende: {
					monthyear: true
				},
				Einwilligung: {
					required: true
				},
				Geburtsdatum: {
					requireddate: true,
					customdob: true,
					under16: true,
					mglratecheck: true
				},
				BestimmungenAkzepiert: {
					required: true,
				},
				FreundschaftswerberCheckbox: {
					required: true,
				},
				FreundschaftswerberCheckboxIntro: {
					required: true,
				},
				KooperationAkzeptiert: {
					required: true,
				},
				WiederrufAkzeptiert: {
					required: true,
				},
				FileRequired: {
					filerequired: true
				},
				"Antragssteller.Datenverwendung.Einwilligung": {
					commercialapproval: true,
					oneoptinrequired: true
				},
				Password: {
					required: true,
					customflagvalidation: true,
					'password': true,
					equalTo: '#password'
				},
				Ausweisnummer: {
					required: true,
					maxlength: 25,
					minlength: 2
				},
				Behinderungsgrad: {
					required: true,
					min: 50
				},
				FamilyConsent: {
					required: true
				},
				Profiwerbernummer: {
					required: true,
					salesman: true
				},
				GeschaeftsstellenWBS: {
					required: true,
					officeadvertisingkey: true,
					maxlength: 4
				},
				MitgliedschaftStartDatum: {
					startofmembership: true,
					startofmembershipcheck: true,
					startofmembershippredate2m: false,
					startofmembershippredate6m: false
				},
				Bonuscode: {
					required: true,
					maxlength: 8
				},
				// for the subapplication
				Bankleitzahl: {
					required: true,
					minlength: 8,
					maxlength: 8,
					customflagvalidation: true
				},
				Kontonummer: {
					required: true,
					maxlength: 10,
					customflagvalidation: true
				},
				"Bankdaten.Iban": {
					required: true,
					customiban: true,
					maxlength: 42,
					customflagvalidation: true,
					oneibanrequired: false
				},
				"Bankdaten.Bic": {
					required: true,
					maxlength: 11,
					customflagvalidation: true
				},
				DigitaleClubkarte: {
					required: true
				},
				Mitgliedsnummer: {
					required: true,
					minlength: 9,
					maxlength: 9,
					pattern: "[0-9]+"
				}
			}
		},
		validationmessages: {
			client: {
				Vorname: {
					minlength: "Bitte mindestens {0} Buchstaben",
					maxlength: "Bitte maximal {0} Buchstaben",
					nonumber: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					required: "Sie haben keinen Vornamen eingegeben. Bitte korrigieren Sie ihre Eingabe!",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				Nachname: {
					minlength: "Bitte mindestens {0} Buchstaben",
					maxlength: "Bitte maximal {0} Buchstaben",
					required: "Sie haben keinen Nachname eingegeben. Bitte korrigieren Sie ihre Eingabe!",
					nonumber: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
				},
				Anrede: {
					required: "Bitte geben Sie Ihre Anrede ein."
				},
				StrasseHausnummer: {
					required: "Bitte geben Sie den Straßennamen und die Hausnummer ein.",
					minlength: "Bitte geben Sie mindestens {0} Zeichen ein.",
					maxlength: "Bitte geben Sie maximal {0} Zeichen ein.",
					streetandnumber: "Bitte korrigieren Sie Ihre Eingabe! Erlaubt sind folgende Sonderzeichen: .,-/’."
				},
				Ort: {
					maxlength: "Fehler Ort max",
					required: "Bitte geben Sie die gültige Postleitzahl und den Wohnort ein."
				},
				Geburtsdatum: {
					requireddate: "Bitte geben Sie ein gültiges Geburtsdatum ein.",
					under16: "Verträge dürfen erst ab 16 Jahre abgeschlossen werden.",
					customdob: "Bitte geben Sie das Geburtsdatum in dem richtigen Format ein TT.MM.JJJJ"
				},
				Postleitzahl: {
					maxlength: "Bitte maximal 5 Zahlen",
					minlength: "Bitte mindestens 5 Zahlen",
					required: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				TelefonVorwahl: {
					inputcross: "Bitte Vorwahl und Rufnummer angeben.",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					maxlength: "Bitte maximal {0} Zahlen",
					required: "Bitte Vorwahl und Rufnummer angeben."
				},
				TelefonNummer: {
					inputcross: "Bitte Vorwahl und Rufnummer angeben.",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					maxlength: "Bitte maximal {0} Zahlen",
					required: "Bitte Vorwahl und Rufnummer angeben."
				},
				TelefonGeschaeftlichVorwahl: {
					inputcross: "Bitte Vorwahl und Rufnummers angeben.",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					maxlength: "Bitte maximal {0} Zahlen"
				},
				TelefonGeschaeftlichNummer: {
					inputcross: "Bitte Vorwahl und Rufnummers angeben.",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					maxlength: "Bitte maximal {0} Zahlen"
				},
				Email: {
					email: "Die E-Mail-Adresse ist nicht gültig!",
					required: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				EmailBonuscode: {
					email: "Die E-Mail-Adresse ist nicht gültig!",
					required: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				EmailSecondTry: {
					email: "Die E-Mail-Adresse ist nicht gültig!",
					required: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					emailsecondtry: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				Ausbildungsende: {
					monthyear: "Bitte geben Sie ein Ausbildungsende ein."
				},
				BestimmungenAkzepiert: {
					required: "Diese Option muss ausgewählt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				FreundschaftswerberCheckbox: {
					required: "Diese Option muss ausgewählt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				FreundschaftswerberCheckboxIntro: {
					required: "Diese Option muss ausgewählt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				KooperationAkzeptiert: {
					required: "Diese Option muss ausgewählt sein! Bitte prüfen Sie Ihre Eingabe!",
				},
				WiederrufAkzeptiert: {
					required: "Diese Option muss ausgewählt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				FileRequired: {
					filerequired: "Bitte wählen Sie eine Datei aus."
				},
				"Antragssteller.Datenverwendung.Einwilligung": {
					commercialapproval: "Diese Option muss ausgewählt sein! Bitte prüfen Sie Ihre Eingabe!",
					oneoptinrequired: "Bitte wählen Sie eine Option"
				},
				Ausweisnummer: {
					required: "Bitte geben Sie Ihre Ausweisnummer ein.",
					maxlength: "Bitte maximal {0} Zeichen.",
					minlength: "Bitte mindestens {0} Zeichen.",
				},
				Behinderungsgrad: {
					required: "Bitte geben Sie Ihren Behinderungsgrad ein.",
					min: "Bitte geben Sie einen Wert größer als 50 ein."
				},
				FamilyConsent: {
					required: "Diese Option muss ausgewählt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				Profiwerbernummer: {
					required: "Bitte geben Sie an dieser Stelle die 7-8-stellige Vertriebspartner-Nummer ein (ohne \" / \").",
					salesman: "Die Vertriebspartner-Nummer ist ungültig."
				},
				GeschaeftsstellenWBS: {
					required: "Bitte Nummer ergänzen",
					officeadvertisingkey: "Bitte geben Sie eine korrekte Nummer ein.",
					maxlength: "Bitte maximal {0} Zeichen."
				},
				MitgliedschaftStartDatum: {
					startofmembership: "Bitte korrigieren Sie Ihre Eingabe.",
					startofmembershipcheck: "Bitte korrigieren Sie Ihre Eingabe.",
					startofmembershippredate2m: "Bitte nur Vordatierung von 2 Monate erlaubt----------",
					startofmembershippredate6m: "Bitte nur Vordatierung von 6 Monate erlaubt----------- ",
				},
				Bonuscode: {
					required: "Bitte geben Sie den Berechtigungscode ein, den Sie von {kooperationspartner} erhalten haben.",
					maxlength: "Der eingegebene Wert ist zu lang."
				},
				// for the subapplication
				"Bankdaten.Bic": {
					required: "Bitte geben Sie eine gültige BIC an.",
					maxlength: "Bitte maximal {0} Zeichen."
				},
				"Bankdaten.Iban": {
					required: "Bitte geben Sie eine gültige IBAN ein!",
					maxlength: "Bitte maximal {0} Zeichen."
				},
				Bankleitzahl: {
					required: "Die Bankleitzahl muss ausgefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					minlength: "Bitte mindestens {0} Zahlen",
					maxlength: "Bitte maximal {0} Zahlen",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!"
				},
				Kontonummer: {
					required: "Die Kontonummer muss ausgefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					maxlength: "Bitte maximal {0} Zahlen",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!"
				},
				DigitaleClubkarte: {
					required: "Bitte füllen Sie dieses Feld aus."
				},
				Mitgliedsnummer: {
					required: "Bitte geben Sie Ihre bisherige Mitgliedsnummer ein",
					minlength: "Die Mitgliedsnummer muss 9 stellig sein",
					maxlength: "Die Mitgliedsnummer muss 9 stellig sein",
					pattern: "Bitte geben Sie nur Ziffern ein"
				}
			},
			backend: {
			}
		}
	}
};
